// register component(s) with react habitat
import codeSplit from '@/higher-order-components/codeSplit';

export default {
	FloorPlansGallery: codeSplit( {
		loadComponent: () =>
			import(
				/* webpackChunkName: "FloorPlansGallery" */
				'./index'
			),
	} ),
};
